export const convertToUrlParams = (
  searchParams: SearchParams
): URLSearchParams => {
  const params = new URLSearchParams();
  if (searchParams.keyword !== undefined) {
    params.append('keyword', searchParams.keyword);
  }
  if (searchParams.category !== undefined) {
    params.append('category', String(searchParams.category));
  }
  if (searchParams.area !== undefined) {
    params.append('area', String(searchParams.area));
  }
  if (searchParams.dates !== undefined) {
    params.append('dates', searchParams.dates);
  }
  if (searchParams.sort !== undefined) {
    params.append('sort', searchParams.sort);
  }
  if (searchParams.page !== undefined) {
    params.append('page', String(searchParams.page));
  }
  return params;
};
